module.exports = __webpack_public_path__ + "img/Location of the Truck.bb4d1474.png";